import Base from './condition-base'
import renderFields from './fake-call-declined.pug'

export default class FakeCallDeclined extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
